<template>

    <header>
        <div class="row-black no-padding-bottom clearfix">
            <div class="content-960">

                <div class="menu pull-left bt-mobile">
                    <div class="dropdown menu-mobile">
                        <b-dropdown class="text-white" variant="link" no-caret>
                            <b-dropdown-item v-canaccess="'/home'">
                                <router-link to="/home">Home</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/iniciarprocessoseletivo'">
                                <router-link to="/iniciarprocessoseletivo">Iniciar Processo Seletivo</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/colaborador'">
                                <router-link to="/colaborador">Colaboradores / Candidatos</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/candidato'">
                                <router-link to="/candidato">Testes / Entrevistas</router-link>
                            </b-dropdown-item>

                            <b-dropdown-divider></b-dropdown-divider>

                            <b-dropdown-item v-canaccess="'/questao'">
                                <router-link to="/questao">Questões</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/avaliacao'">
                                <router-link to="/avaliacao">Testes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/tagjobs'">
                                <router-link to="/tagjobs">Tags</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxconceito'">
                                <router-link to="/auxconceito">Conceitos</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdisciplina'">
                                <router-link to="/auxdisciplina">Disciplina</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdificuldade'">
                                <router-link to="/auxdificuldade">Dificuldade</router-link>
                            </b-dropdown-item>

                        </b-dropdown>
                    </div>
                </div>

                <a href="/home" title="Logo CNA Portal Corporativo" class="logo-header">
                    <img src="../assets/imagens/logos/logo-CNA-big.png" alt="Imagem Logo CNA" title="CNA Jobs" class="logo-desktop" />
                    <img src="../assets/imagens/logos/logo-CNA-mobile.png" alt="Imagem Logo CNA" title="CNA Jobs" class="logo-mobile margin-ajust" />
                </a>

                <div class="user">
                    <div class="click-menu click-animate">
                        <div class="img-user">
                            <img :src="urlFoto" alt="Imagem do Usuário" :title="user.name" />
                        </div>
                        <h2>Olá, <span :title="user.name">{{user.name}}</span></h2>
                        <div class="cna-local">
                            <span :title="escolaNome">{{escolaNome}}</span>

                            <a class="icons-arrows" href="javascript:void(0);" @click="irParaPortalCorporativo()">
                                <span><br />Ir para Portal Corporativo</span>
                            </a>

                            <router-link to="/trocarescola" class="icons-arrows">
                                <span><br />Trocar escola</span>
                            </router-link>

                            <a class="float-right" style="cursor: pointer;" @click="logout()">
                                Sair
                            </a>

                        </div><br />
                    </div>
                    <div class="wrap-conteudo">
                        <div class="dados-user-mobile">
                            <h2>Olá, <span>{{user.name}}</span></h2>
                            <div class="cna-local">
                                {{escolaNome}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-desktop">
                    <ul class="style-hover">

                        <li v-canaccess="'/home'">
                            <router-link to="/home">Home</router-link>
                        </li>

                        <li id="div-iniciarprocessoseletivo" v-canaccess="'/iniciarprocessoseletivo'">
                            <router-link to="/iniciarprocessoseletivo">Iniciar Processo Seletivo</router-link>
                        </li>
                        <li id="div-colaborador" v-canaccess="'/colaborador'">
                            <router-link to="/colaborador">Colaboradores / Candidatos</router-link>
                        </li>
                        <li id="div-candidato" v-canaccess="'/candidato'">
                            <router-link to="/candidato">Testes / Entrevistas</router-link>
                        </li>
                        <b-nav-item-dropdown v-canaccess="'/relatorios'" class="menu-color" text="Relatórios" left>

                            <b-dropdown-item v-canaccess="'/relatorios/colaboradores'">
                                <router-link to="/relatorios/colaboradores">Colaboradores</router-link>
                            </b-dropdown-item>

                        </b-nav-item-dropdown>

                        <b-nav-item-dropdown v-canaccess="'/gerencial'" class="menu-color" text="Gerencial" left>

                            <b-dropdown-item v-canaccess="'/questao'">
                                <router-link to="/questao">Questões</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/avaliacao'">
                                <router-link to="/avaliacao">Testes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/tagjobs'">
                                <router-link to="/tagjobs">Tags</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxconceito'">
                                <router-link to="/auxconceito">Conceitos</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdisciplina'">
                                <router-link to="/auxdisciplina">Disciplina</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/auxdificuldade'">
                                <router-link to="/auxdificuldade">Dificuldade</router-link>
                            </b-dropdown-item>

                        </b-nav-item-dropdown>

                    </ul>
                </div>
            </div>
        </div>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" :hide-header-close="true" centered v-model="dialogDetalheMelhoria" :hide-footer="true" title="Detalhes da Atualização" content-class="ObrLeitura">
            <form-detalhe-atualizacao v-if="dialogDetalheMelhoria" @on-saved="onSaved" @on-back="hideAll()" :textoAtualizacao="textoDetalheAtualizacao" :id="changeLogId" />
        </b-modal>
    </header>

</template>
<script>

    import Global from '@/common/global'
    import Auth from '@/common/auth'
    import formDetalheAtualizacao from './form-detalhe-atualizacao'
    import { Api } from '@/common/api'

    export default {
        name: "header-cna",
        components: { formDetalheAtualizacao },
        data() {
            return {
                urlPortalCorporativo: Global.URL_PORTAL_CORPORATIVO,
                user: { escolas: [] },
                foto: '',
                escolaLogadaId: 0,                
                dialogDetalheMelhoria: false,
                result: {},
                textoDetalheAtualizacao: "",
                changeLogId: 0
            }
        },
        computed: {
            urlFoto() {
                return Global.URL_DOWNLOAD + "colaborador-foto/" + this.foto + "?v=" + Math.random();
            },
            escolaNome() {
                var escola = this.user.escolas.filter(_ => _.escolaId == +this.user.tenant)[0];
                if (escola) return escola.nomeEscola
                return "--";
            }
        },
        methods: {
            irParaPortalCorporativo: function () {
                sessionStorage.clear();
                window.location = this.urlPortalCorporativo;
            },
            logout: function () {
                Auth.logout()
            },
            openDetalheMelhoria: function (show) {
                this.dialogDetalheMelhoria = show;
            },            
            executeLeituraObrigatoria: function (show) {
                if (show) this.openDetalheMelhoria();
            },
            hideAll: function () {
                this.dialogDetalheMelhoria = false;
            },
            onSaved: function (data) {
                this.hideAll();
                //this.openEdit(data.data)
            },
        },
        mounted() {
            this.user = Auth.currentUser();
            this.foto = Auth.getFotoUser();

            this.usuarioLogado = this.user.sub;

            new Api("ChangeLog/GetDetalheAtualizacao").get({ sistemaId: 6121, EhLeituraObrigatoria: true, attributeBehavior: "DetalheAtualizacao" }).then(data => {
                if (data.dataList.length > 0) {
                    this.changeLogId = data.dataList[0].id;
                    this.textoDetalheAtualizacao = data.dataList[0].detalheAtualizacao;
                    
                    new Api("ChangeLogConfirmacaoLeitura/GetLeituraConfirmacao").get({ ColaboradorId: this.usuarioLogado, attributeBehavior: "ConfirmacaoLeituraColaborador" }).then(resultado => {
                        if (resultado.data == null)
                            this.openDetalheMelhoria(true);
                    }, err => {
                        this.defaultErrorResult(err);
                    })
                } else {
                    //console.log("sem resultado");
                }

            }, err => {
                this.defaultErrorResult(err);
            })
        },

    };
</script>
